module.exports = __webpack_public_path__ + "media/src/images/icons/issue-25e33e231547d6724269194b45828ac0.svg";